import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f8f00d6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon bi-chevron-left" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon bi-chevron-right" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "wrapper-box" }
const _hoisted_7 = { class: "box" }
const _hoisted_8 = { class: "nav nav-pills" }
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "arrow left",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scroll_left && _ctx.scroll_left(...args)))
    }, _hoisted_3),
    _createElementVNode("div", {
      class: "arrow right",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.scroll_right && _ctx.scroll_right(...args)))
    }, _hoisted_5),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("nav", _hoisted_8, [
          _createElementVNode("button", {
            class: _normalizeClass(["nav-link mx-1 px-4 mb-0", ['All' === _ctx.activeTab ? 'active' : '']]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => {
              _ctx.getAll();
              _ctx.filterByTag({
                name: 'All',
                id: 'All',
              });
            })
          }, " All ", 2),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTags, (item, i) => {
            return _withDirectives((_openBlock(), _createElementBlock("button", {
              class: _normalizeClass(["nav-link mx-1 px-4 mb-0", [item.name === _ctx.activeTab ? 'active' : '']]),
              key: i,
              onClick: ($event: any) => (_ctx.filterByTag(item))
            }, [
              _createTextVNode(_toDisplayString(item.name), 1)
            ], 10, _hoisted_9)), [
              [
                _directive_tooltip,
                item.description || item.name,
                void 0,
                { top: true }
              ]
            ])
          }), 128))
        ])
      ])
    ])
  ]))
}